import * as api from '../api';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { 
  GET_USER_ADRESSES, 
  GET_ORDERS,
  GET_ORDER,
  GET_VIEW_PROFILE,
  GET_CARS,
  GET_BRANCH_PRODUCTS_LIST,
  GET_PAYMENTS,
  GET_PARTNER_PROGRAM_PRODUCTS,
  GET_PARTNER_PROGRAM_CATEGORIES,
  GET_FAVORITE_PRODUCTS,
  ADD_FAVORITE_PRODUCTS,
  DEL_FAVORITE_PRODUCT
} from '../constants/action-types';

export const addAddress = (token, form, setOpen, setReload) => dispatch => {
  api.addUserAddress(token, form, setOpen, setReload).then(addAddress => {
    toast.success("Adres został dodany.");
    return addAddress;
  })
}

export const updateAddress = (token, form, setOpen, setReload) => dispatch => {
  api.updateUserAddress(token, form, setOpen, setReload).then(updateAddress => {
    toast.success("Adres został zmieniony.");
    return updateAddress;
  })
}

export const getUserAddresses = (token, setReload) => dispatch => {
  api.getUserAddresses(token, setReload).then(userAddresses => {
    dispatch(receiveUserAddresses(userAddresses));
    return userAddresses;
  })
}

export const setUserAddressAsDefault = (token, form, setReload) => dispatch => {
  api.setUserAddressAsDefault(token, form, setReload).then(addressDefault => {
    toast.success("Adres domyślny został zmieniony.");
    return addressDefault;
  })
}

export const deleteUserAddress = (token, address_id, setReload) => dispatch => {
  api.deleteUserAddress(token, address_id, setReload).then(deleteAddress => {
    toast.success("Adres został usunięty.");
    return deleteAddress;
  })
}

export const viewProfile = (token, setUserSession) => dispatch => {
  api.viewProfile(token, setUserSession).then(viewProfile => {
    dispatch(receiveViewProfile(viewProfile));
    return viewProfile;
  })
}

export const updateProfile = (token, form, setUserSession, setReload) => dispatch => {
  api.updateProfile(token, form, setUserSession, setReload).then(updateProfile => {
    toast.success("Dane zostały zaktualizowane.");
    return updateProfile;
  })
}

export const userLogin = (email, password, setUserSession, setError, location, setLoggedIn, setUserModal) => dispatch => {
  api.userLogin(email, password, setUserSession, setError, location, setLoggedIn, setUserModal).then(userLogin => {
    return userLogin;
  })
}

export const userLoginFB = (data, setUserSession, location, setLoggedIn, setUserModal) => dispatch => {
  api.loginFB(data, setUserSession, location, setLoggedIn, setUserModal).then(u => {
    toast.success("Zalogowano pomyślnie.");
    window.location = `${location.state ? location.state.from : location.pathname ? location.pathname : '/'}`;
    // props.history.push(props.location.state ? props.location.state.from : props.location.pathname ? props.location.pathname : '/', props.location.productPricingQty ? {qty: props.location.productPricingQty, product: props.location.productPricing} : null);
    return u;
  }).catch(error => {
    toast.error("Wystąpił błąd, spróbuj ponownie.");
  })
}

export const registerClient = (form, setSuccess, setSendRegister) => dispatch => {
  api.registerClient(form, setSuccess, setSendRegister).then(register => {
    return register;
  }).catch(error => {
    setSendRegister(false);
    toast.error("Wystąpił błąd, spróbuj ponownie.");
  })
}

export const registerContractor = (form, setSuccess, setSendRegister) => dispatch => {
  api.registerContractor(form, setSuccess, setSendRegister).then(register => {
    return register;
  })
}

export const confirmToken = (token, setConfirmError) => dispatch => {
  api.confirmToken(token, setConfirmError).then(confirm => {
    toast.success("Adres e-mail potwierdzony.");
    return confirm;
  })
}

export const passwordReset = (form, setSuccess, setPasswdReset) => dispatch => {
  api.passwordReset(form, setSuccess, setPasswdReset).then(passwd => {
    return passwd;
  }).catch(error => {
    setPasswdReset(false);
    toast.error("Wystąpił błąd, spróbuj ponownie.");
  })
}

export const getOrders = (token) => dispatch => {
  api.getOrders(token).then(orders => {
    dispatch(receiveOrders(orders));
    return orders;
  })
}

export const viewOrder = (token, order_id, setOrder) => dispatch => {
  api.viewOrder(token, order_id, setOrder).then(order => {
    dispatch(receiveOrder(order));
    return order;
  })
}

export const setOrderDelivered = (token, order_id, setIsDelivered) => dispatch => {
  api.setOrderDelivered(token, order_id, setIsDelivered).then(orderDelivered => {
    toast.success("Zamówienie zrealizowane.");
    return orderDelivered;
  })
}

export const providerCancelOrder = (token, order_id, setIsCancelOrderBuy) => dispatch => {
  api.providerCancelOrder(token, order_id, setIsCancelOrderBuy).then(orderCanceled => {
    toast.success("Zamówienie zostało anulowane.");
    return orderCanceled;
  })
}

export const clientCancelOrder = (token, order_id, setIsCancelPricing) => dispatch => {
  api.clientCancelOrder(token, order_id, setIsCancelPricing).then(orderCancelClient => {
    toast.success("Wycena została anulowana.");
    return orderCancelClient;
  })
}

export const pricingOrder = (token, form, setIsSendPricing) => dispatch => {
  api.pricingOrder(token, form, setIsSendPricing).then(pricingOrder => {
    toast.success("Wycena została przesłana.");
    return pricingOrder;
  })
}

export const acceptPricing = (token, form, setPaymentToken, setLoading, setIsAcceptPricing) => dispatch => {
  api.acceptPricing(token, form, setPaymentToken, setLoading, setIsAcceptPricing).then(pricingAccept => {
    toast.success("Wycena została zaakceptowana.");
    return pricingAccept;
  }).catch(() => {})
}

export const getCars = (token, setReload) => dispatch => {
  api.getCars(token, setReload).then(getCars => {
    dispatch(receiveGetCars(getCars));
    return getCars;
  })
}

export const deleteCar = (token, branch_car_id, setReload) => dispatch => {
  api.deleteCar(token, branch_car_id, setReload).then(deleteCar => {
    toast.success("Auto zostało usunięte.");
    return deleteCar;
  })
}

export const addCar = (token, form, setOpen, setReload) => dispatch => {
  api.addCar(token, form, setOpen, setReload).then(addCar => {
    toast.success("Auto zostało dodane.");
    return addCar;
  })
}

export const updateCar = (token, form, setOpen, setReload) => dispatch => {
  api.updateCar(token, form, setOpen, setReload).then(updateCar => {
    toast.success("Dane auta zostały zmienione.");
    return updateCar;
  })
}

export const setState = (token, form) => dispatch => {
  api.setState(token, form).then(setState => {
    return setState;
  })
}

export const timeoutPricing = (token, value) => dispatch => {
  api.timeoutPricing(token, value).then(timeoutPricing => {
    return timeoutPricing;
  })
}

export const getBranchProductsList = (token, setReload) => dispatch => {
  api.branchProductsList(token, setReload).then(productList => {
    dispatch(receiveBranchProductsList(productList));
    return productList;
  })
}

// export const getBranchProductsListPage = (token, pageNumber, toTop) => dispatch => {
//   api.branchProductsListPage(token, pageNumber, toTop).then(productList => {
//     dispatch(receiveBranchProductsList(productList));
//     return productList;
//   })
// }

export const addBranchProduct = (token, form, setReload) => dispatch => {
  api.addBranchProduct(token, form, setReload).then(addBranchProduct => {
    toast.success("Produkt został dodany.");
    return addBranchProduct;
  })
}

export const deleteBranchProduct = (token, form, setReload) => dispatch => {
  api.deleteBranchProduct(token, form, setReload).then(delBranchProduct => {
    toast.success("Produkt został usunięty.");
    return delBranchProduct;
  })
}

export const retryPaymentTransaction = (token, order_id, setPaymentToken, setLoading) => dispatch => {
  api.retryPaymentTransaction(token, order_id, setPaymentToken, setLoading).then(retryPayment => {
    return retryPayment;
  })
}

export const getPayments = (token, user_id) => dispatch => {
  api.getUserPayments(token, user_id).then(payments => {
    dispatch(receivePayments(payments));
    return payments;
  })
}

export const getPartnerProgramProducts = (token, setData) => dispatch => {
  api.getPartnerProgramProducts(token, setData).then(ppProducts => {
    dispatch(receivePartnerProgramProducts(ppProducts));
    return ppProducts;
  })
}

export const getPartnerProgramCategories = (token) => dispatch => {
  api.getPartnerProgramCategories(token).then(ppCategories => {
    dispatch(receivePartnerProgramCategories(ppCategories));
    return ppCategories;
  })
}

export const getFavoriteProducts = (user_id) => dispatch => {
  api.getFavoriteProducts(user_id).then(fp => {
    dispatch(receiveFavoriteProducts(fp));
    return fp;
  })
}

export const addFavoriteProduct = (data) => dispatch => {
  api.addFavoriteProduct(data).then(fp => {
    toast.success("Produkt dodano do ulubionych.");
    dispatch(receiveAddFavoriteProduct(fp));
    return fp;
  })
}

export const deleteFavoriteProduct = (id) => dispatch => {
  api.deleteFavoriteProduct(id).then(fp => {
    toast.success("Produkt usunięto z ulubionych.");
    dispatch(receiveDeleteFavoriteProduct(fp));
    return fp;
  })
}

export const confirmSMSToken = (code) => dispatch => {
  api.confirmSMSToken(code).then(a => {
    window.location = '/';
    toast.success("Numer telefonu potwierdzony.");
  }).catch(error => {
    toast.error("Wystąpił błąd, spróbuj ponownie.");
  })
}

export const confirmSMSPasswordReset = (code) => dispatch => {
  api.confirmSMSPasswordReset(code).then(a => {
    toast.success("Nowe hasło wysłane SMS'em.");
    setTimeout(() => {
      window.location = '/logowanie';
    }, 5000);
  }).catch(error => {
    toast.error("Wystąpił błąd, spróbuj ponownie.");
  })
}

export const receiveDeleteFavoriteProduct = fp => ({
  type: DEL_FAVORITE_PRODUCT,
  fp
});

export const receiveAddFavoriteProduct = fp => ({
  type: ADD_FAVORITE_PRODUCTS,
  fp
});

export const receiveFavoriteProducts = fp => ({
  type: GET_FAVORITE_PRODUCTS,
  fp
});

export const receiveUserAddresses = userAddresses => ({
  type: GET_USER_ADRESSES,
  userAddresses
});

export const receiveOrders = orders => ({
  type: GET_ORDERS,
  orders
});

export const receiveOrder = order => ({
  type: GET_ORDER,
  order
});

export const receiveViewProfile = viewProfile => ({
  type: GET_VIEW_PROFILE,
  viewProfile
});

export const receiveGetCars = getCars => ({
  type: GET_CARS,
  getCars
});

export const receiveBranchProductsList = productList => ({
  type: GET_BRANCH_PRODUCTS_LIST,
  productList
});

export const receivePayments = payments => ({
  type: GET_PAYMENTS,
  payments
});

export const receivePartnerProgramProducts = ppProducts => ({
  type: GET_PARTNER_PROGRAM_PRODUCTS,
  ppProducts
});

export const receivePartnerProgramCategories = ppCategories => ({
  type: GET_PARTNER_PROGRAM_CATEGORIES,
  ppCategories
});